const checkBefore500FirmwareVersion = (firmware: string): boolean => {
  if (!firmware) {
    return true
  }
  return firmware.split('.')[1] !== '05'
}

export default checkBefore500FirmwareVersion
